<template>
    <Section
        #default="{ data: dictionaries = [], isResolving, isResolved, isRejected, execute }"
        endpoint="dictionaries.list"
        :transform="transform"
    >
        <div class="Wrapper">
            <WText
                tag="label"
                typo="label"
                size="14"
            >
                {{ $t('entities.creation.labels.dictionaries') }}
            </WText>
            <div v-if="!isRejected">
                <WSelect
                    v-if="(dictionaries || []).length"
                    :value="value"
                    name="dictionary"
                    :placeholder="$t('entities.creation.placeholder.dictionary')"
                    :options="dictionaries"
                    :disabled="isLoading || isResolving"
                    @input="handleInput"
                />
            </div>
            <WText
                v-else-if="isRejected"
                visible
            >
                {{ $t('actions.retry.text') }}
                <a @click="execute">{{ $t('actions.retry.link') }}</a>
            </WText>
        </div>
    </Section>
</template>

<script>
import VueTypes from 'vue-types'
import { Section } from '@/components'

const TYPES = {
    EXTERNAL: 'external',
    INTERNAL: 'internal',
}

export default {
    name: 'Dictionaries',
    components: {
        Section,
    },
    props: {
        value: VueTypes.string,
        isLoading: VueTypes.bool.def(false),
    },
    methods: {
        handleInput (value) {
            this.$emit('input', value)
        },
        transform ({ data }) {
            return (data || []).map(dictionary => ({
                ...dictionary,
                label: dictionary.name,
            })).filter(({ type }) => type !== TYPES.INTERNAL)
        },
    },
}
</script>
